import { render } from "./TypeClientSettings.vue?vue&type=template&id=363d257e&ts=true"
import script from "./TypeClientSettings.vue?vue&type=script&lang=ts"
export * from "./TypeClientSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__